export type NvsEffectsSelectorProps = {
  effects: EffectsMappingProps;
  enabled?: boolean;
};

export type EffectsMappingProps = { effectType: string; name: string }[];

export type FxConfigProps = {
  bloom: boolean;
  dotScreen: boolean;
  noise: boolean;
  chromaticAberration: boolean;
  toneMapping: boolean;
};

export enum EffectType {
  Bloom = "Bloom",
  ChromaticAberration = "ChromaticAberration",
  DotScreen = "DotScreen",
  Noise = "Noise",
  ToneMapping = "ToneMapping",
}

export type EffectsTypes = keyof typeof EffectType;
